<template>
	<v-card class='session-card elevation-0 d-flex flex-column'>
		<div class='session-card__container'>
			<div class='session-card__outer'>
				<div class='d-flex session-card__list pl-0 pr-0'>
					<SessionCard :agenda-event='this.session' />
				</div>
			</div>
		</div>
	</v-card>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import SessionCard from '@/components/Event/SessionCard'


Vue.use(VueScrollTo)

export default {
	components: {
		SessionCard,
	},
	props: {
		event: {
			type: Object,
			default: () => {
			},
		},
		session: {
			type: Object,
			default: () => {
			},
		},
	}
}
</script>

<style lang='scss'>
.v-card__text {
	padding: 0;
}

.session-card {
	background: #f1f1f1 !important;

	&__container {
		width: 100%;
		height: 100%;
		border-radius: 10px !important;
		margin-bottom: 30px;
	}

	&__content-inner {
		color: rgb(74, 74, 74);
		font-size: 15px;
		font-family: Montserrat, sans-serif;
		font-weight: normal;
		line-height: 18px;
		padding-top: 10px;

		img {
			width: 100%;
		}

		p {
			margin-bottom: 0;
		}

		h1 {
			font-size: 30px;
			padding-bottom: 8px;
			line-height: 30px;
		}
	}

	&__meta {
		font-family: Montserrat, sans-serif;
		font-style: normal;
		font-weight: bold;
		font-size: 18px;
		line-height: 20px;
		color: rgb(66, 160, 216);
		letter-spacing: 0.36px;
		gap: 4px;

		&-bottom {
			color: rgb(155, 155, 155);
			font-size: 16px;
			font-family: Montserrat, sans-serif;
			font-weight: normal;
			line-height: 16px;
		}

		&-time {
			color: rgb(155, 155, 155);
			font-size: 12px;
			font-family: Montserrat, sans-serif;
			font-weight: normal;
			text-align: right;
		}
	}

	&__list {
		position: relative;
		flex-direction: column;
	}

	&__title {
		color: rgb(74, 74, 74);
		font-size: 24px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
	}

	&__event-time {
		color: rgb(74, 74, 74);
		font-size: 15px;
		font-family: Montserrat, sans-serif;
		font-weight: 600;
	}

	&__attendees {
		&-member {
			width: 50px;
			height: 50px;
			border-radius: 50%;
			object-fit: cover;
		}

		&-last-member {
			position: absolute;
			top: 0;
			bottom: 0;
			left: 0;
			right: 0;
			z-index: 999;
			background-color: rgba(0, 0, 0, 0.6);
			color: white;
			font-family: "Montserrat", sans-serif;
			font-size: 14px;
			display: flex;
			justify-content: center;
			align-items: center;
			line-height: 3.7;

			width: 60px;
			height: 60px;
			border-radius: 50%;
		}

		&-last-container {
			position: relative !important;
			width: 60px !important;
		}

	}

	&__event {
		&-wrapper {
			display: flex;
			align-items: center;
			gap: 10px;
			width: 250px;
			margin-bottom: 20px;
			margin-right: 10px;

			i {
				border-radius: 50%;
				min-width: 40px;
				min-height: 40px;
			}
		}

		&-title {
			color: rgb(74, 74, 74);
			font-size: 16px;
			font-family: Montserrat, sans-serif;
			font-weight: normal;
		}
	}

	&__exhibitors {

		&-container {
			display: flex;
			flex-wrap: wrap;
			align-items: center;
			padding: 10px 20px;
			gap: 15px 75px;
		}

		&-more {
			color: var(--accent-color);
			font-size: 14px;
			font-family: Montserrat, sans-serif;
			font-weight: bold;
			text-decoration: underline;
			text-align: right;
		}

		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		align-items: center;

		img {
			width: 120px;
		}

	}

	&__subtitle {
		&-category {
			color: rgb(155, 155, 155);
			font-size: 14px;
			font-family: Montserrat, sans-serif;
			font-weight: bold;
		}

		color: rgb(74, 74, 74);
		font-size: 16px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
	}

	&__address {
		color: rgb(74, 74, 74);
		font-size: 15px;
		font-family: Montserrat, sans-serif;
		font-weight: normal;
		line-height: 20px;
	}

	&__registered {
		color: rgb(255, 255, 255) !important;
		font-size: 16px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
		text-align: center;
		background-color: #a0a0a0 !important;
		border-radius: 8px;
		height: 50px !important;
		width: 100%;
	}

	&__register {
		color: rgb(255, 255, 255) !important;
		font-size: 16px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
		text-align: center;
		background-color: #58b957 !important;
		border-radius: 8px;
		height: 50px !important;
		width: 100%;
	}

	&__description {
		color: rgb(74, 74, 74);
		font-size: 15px;
		font-family: Montserrat, sans-serif;
		font-weight: normal;
		line-height: 22px;

		table {
			margin: 15px auto;
			border-collapse: collapse;
			font-family: Montserrat, sans-serif;
		}

		table td {
			padding: 15px;
			text-align: center;
		}

		table th {
			padding: 15px;
		}

		table thead td {
			background-color: #54585d;
			color: #ffffff;
			font-weight: bold;
			font-size: 13px;
			border: 1px solid #54585d;
			text-align: center;
		}

		table thead th {
			border: 1px solid #dddfe1;
		}

		table tbody td {
			color: #636363;
			border: 1px solid #dddfe1;
		}

		table tbody th {
			border: 1px solid #dddfe1;
		}

		table tbody tr {
			background-color: #f9fafb;
		}

		table tbody tr:nth-child(odd) {
			background-color: #ffffff;
		}
	}


	&__thumbnail {
		height: auto;
		width: 100%;
		border-radius: 10px;
		position: relative;
	}

	&__tag {
		padding: 6px;
		border-radius: 3px !important;
		color: rgb(74, 74, 74);
		font-size: 14px !important;
		font-family: Montserrat, sans-serif;
		font-weight: normal;
		height: 20px !important;
		cursor: pointer;

		span {
			min-width: 100% !important;
			width: 100%;
		}
	}

	@media screen and (max-width: 1904px) {
		&__block {
			flex: 0 0 100%;
		}
		&__list {
			flex: 0 0 75%;
		}
	}
	@media screen and (max-width: 1264px) {
		&__block {
			flex: 0 0 100%;
		}
		&__list {
			flex: 0 0 66%;
		}
	}

	@media screen and (min-width: 1264px) {
		&__container {
			max-width: 600px;
		}
	}
	@media screen and (max-width: 768px) {
		&__thumbnail {
			max-height: 250px;
			height: 100%;
			max-width: 100%;
			border-radius: 10px;
		}
		&__default-thumbnail {
			max-height: 250px;
			height: 100%;
		}
		&__outer {
			flex-direction: column;
		}
	}
}

</style>
